export default __webpack_public_path__ + "static/media/profile_picture_2.f47211a1.jpg";